import React, { useContext } from "react";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { Dropdown } from "primereact/dropdown";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { confirmDialog } from "primereact/confirmdialog";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { chageEstadoRedes } from "../../../../../../API/IT/Dispositivos/DispositivosRequest";

const RedesScreen = ({
  redes,
  selected,
  setSelected,
  loading,
  setShowDialog,
  toast,
  estados,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          placeholder="Estados"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdRed: item.IdRed,
                  IdEstado: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdRed: data.IdRed,
                IdEstado: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName}?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdRedes = changes.map((item) => item.IdRed);
                cambiarEstado(e.value.IdStatus, IdRedes.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdRedes) => {
    const result = await chageEstadoRedes({ IdStatus, IdRedes });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const colums = [
    {
      field: "IdRed",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "DireccionIP",
      header: "IP",
      headerEn: "IP",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreDispositivo",
      header: "Nombre Dispositivo",
      headerEn: "Name Device",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "TipoDispositivo",
      header: "Tipo Dispositivo",
      headerEn: "Type Device",
      className: "large",
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "large",
    },
    {
      field: "modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "large",
    },
    {
      field: "serie",
      header: "Serie",
      headerEn: "Serial",
      className: "large",
    },
    {
      field: "NombreActivo",
      header: "Activo",
      headerEn: "Asset",
      className: "large",
    },
    {
      field: "CodigoNombre",
      header: "Asignado",
      headerEn: "Assigned",
      className: "large",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "large",
    },
    {
      field: "AnyDesk",
      header: "AnyDesk",
      headerEn: "AnyDesk",
      className: "large",
    },
    {
      field: "ClaveAnyDesk",
      header: "Clave AnyDesk",
      headerEn: "AnyDesk Key",
      className: "large",
    },
    {
      header: "Estado",
      headerEn: "Status",
      frozen: true,
      alignFrozen: "right",
      field: "IdEstado",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: true,
    },
    {
      field: "IdRouter",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: redes,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
  };

  return (
    <div
      className="p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <AgGrid table={table} />
    </div>
  );
};

export default RedesScreen;
